@import "./colors.scss";

$LITTLE_SHADOW: 0 0 2px 3px $ACCENT_TEXT;
$LITTLEST_SHADOW: 0 0 1px 2px $ACCENT_TEXT;

._basicInput {
  font-family: $MONOSPACE_FONT;
  background-color: lighten($color: $PAGE_ALT, $amount: 11);
  box-shadow: $LITTLE_SHADOW;
  border: none;
  border-radius: $BORDER_RADIUS;
  text-transform: uppercase;
}

._basicButton {
  font-family: $MONOSPACE_FONT;
  background-color: $ACCENT_ALT;
  box-shadow: $LITTLE_SHADOW;
  border: none;
  border-radius: $BORDER_RADIUS;
  cursor: pointer;
}

.singleLetterInputContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.singleLetterInputChangers {
  @extend ._basicButton;
  font-size: 1.5rem;
  width: calc(3rem + 4px);
  height: 1.5rem;
  z-index: 1;

  &:first-child {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  &:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}

.singleLetterInput {
  @extend ._basicInput;

  z-index: 0;
  height: 3rem;
  width: 3rem;
  font-size: 1.5rem;
  text-align: center;
  border-radius: 0;
}

.keyGroup {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: center;
  min-width: min(20rem, 100vw - 1rem);
}

.inputBox {
  @extend ._basicInput;
  width: min(20rem, 100vw - 4rem);
  margin: 0 auto;
  height: 8rem;
  padding: 0.5rem;
  font-size: 0.9rem;

  &:read-only {
    background-color: $PAGE_BACKGROUND;
    color: lighten($color: $PAGE_TEXT, $amount: 10);
  }
}

.inputRow {
  display: flex;
  gap: 2em;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;

  &:not(:first-child) {
    margin-top: 4rem;
  }
}

.inputColumn {
  display: flex;
  flex-direction: column;

  gap: 1rem;
}

.label {
  border-radius: $BORDER_RADIUS;
  font-family: $MONOSPACE_FONT;
  background-color: $ACCENT_BACKGROUND;
  box-shadow: $LITTLE_SHADOW;
  padding: 0.5rem;
  margin: 0 auto;
}

.histogram {
  position: relative;
  height: 8rem;
  width: min(20rem, 100vw - 2rem);
  border-bottom-left-radius: $BORDER_RADIUS;
  border: solid 0 $ACCENT_TEXT;
  border-bottom-width: 2px;
  border-left-width: 2px;
  margin-top: 2rem;
  margin-bottom: 1.25rem;
}

.histogramBars {
  position: absolute;
  display: flex;
  flex-direction: row;
  bottom: 0;
  width: 100%;
  height: 100%;
  justify-content: space-evenly;
  align-items: flex-end;

  & > * {
    transition: height 0.1s ease-in-out;
    width: 0.25rem;
    min-height: 5px;
    background-color: $ACCENT_BACKGROUND;
    box-shadow: $LITTLEST_SHADOW;
  }
}

.histogramLabels {
  background-color: $PAGE_ALT;
  position: absolute;
  display: flex;
  flex-direction: row;
  font-family: $MONOSPACE_FONT;
  font-size: 0.9rem;
  padding-top: 0.25rem;
  top: calc(100% + 2px);
  width: 100%;
  justify-content: space-evenly;
}

.helpText {
  width: min(20rem, 100vw - 2rem);
  text-align: center;
  font-weight: bold;
  margin-top: -1rem;
  align-self: center;

  p {
    margin-top: 1rem;
  }
}

.button {
  @extend ._basicButton;
  padding: 0.25rem 0.5rem;
}

.addButtonColumn {
  align-self: center;
}

.lineInput {
  @extend ._basicInput;
}
